import { render, staticRenderFns } from "./FormBorrow.vue?vue&type=template&id=f14a9a9c&"
import script from "./FormBorrow.vue?vue&type=script&lang=js&"
export * from "./FormBorrow.vue?vue&type=script&lang=js&"
import style0 from "./FormBorrow.vue?vue&type=style&index=0&id=f14a9a9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports